export default __webpack_public_path__ + "static/19_19-6d68c147694213ddb54da1750fa4500a.png";